import Vue from "vue";
import pxRunner from "@/pixels/runner";

jest.mock("vue", () => ({
  $log: {
    info: jest.fn(),
    error: jest.fn()
  }
}));

jest.mock("@/pixels/pixelDb", () => ({
  providers: {
    mockProvider: {
      enabled: true,
      fx1: jest.fn(),
      queue: []
    }
  }
}));

describe("pxRunner", () => {
  beforeEach(() => {
    jest.useFakeTimers();
    jest.spyOn(pxRunner, "run");
    jest.spyOn(pxRunner, "enableProvider");
  });

  afterEach(() => {
    jest.clearAllTimers();
    jest.clearAllMocks();
  });

  it("runs the fx if the provider is enabled", () => {
    const context = {};
    pxRunner.run("mockProvider.fx1", context);
    expect(Vue.$log.info).toHaveBeenCalledWith("PXI", "mockProvider.fx1");
  });

  it("logs an error if the provider does not exist", () => {
    pxRunner.run("nonExistentProvider.fx1", {});
    expect(Vue.$log.error).toHaveBeenCalledWith(
      "PXI",
      "Error en definición de trigger, el provider no existe: nonExistentProvider.fx1"
    );
  });

  it("logs an error for an invalid trigger definition", () => {
    pxRunner.run("invalidTrigger", {});
    expect(Vue.$log.error).toHaveBeenCalledWith(
      "PXI",
      "Error en definición de trigger: invalidTrigger"
    );
  });

  it("Configuración Pixels enableProvider()", () => {
    const provider = {
      wait: jest.fn(),
      loading: false
    };
    const cb = jest.fn();
    pxRunner.enableProvider(provider, cb);
    const enableProviderMock = jest.spyOn(pxRunner, "enableProvider");
    expect(enableProviderMock).toHaveBeenCalledTimes(1);
  });

  it("Configuración Pixels enableProvider() enabled:true", () => {
    const provider = {
      enabled: true
    };
    const cb = jest.fn();
    pxRunner.enableProvider(provider, cb);
    const enableProviderMock = jest.spyOn(pxRunner, "enableProvider");
    expect(enableProviderMock).toHaveBeenCalled();
  });

  it("Configuración Pixels enableProvider() wait, init", () => {
    const provider = {
      wait: () => ({}),
      init: true
    };
    const cb = jest.fn();
    pxRunner.enableProvider(provider, cb);
    const enableProviderMock = jest.spyOn(pxRunner, "enableProvider");
    expect(enableProviderMock).toHaveBeenCalled();
  });

  it("Configuración Pixels enableProvider() wait:false, loading:true", () => {
    const provider = {
      wait: false,
      loading: true
    };
    const cb = jest.fn();
    pxRunner.enableProvider(provider, cb);
    const enableProviderMock = jest.spyOn(pxRunner, "enableProvider");
    jest.runOnlyPendingTimers();
    expect(enableProviderMock).toHaveBeenCalled();
  });

  it("Configuración exportada por defecto", () => {
    expect(pxRunner).toBeDefined();
    expect(pxRunner).not.toBeNull();
    expect(typeof pxRunner).toBe("object");
  });
});
